<template>
	<main>
		<div class="main">
			<dl class="titleTip">
				<dt>
          <span style="color:#666;cursor: pointer" @click="$router.go(-1)">病例分析 ></span>
          <span> 病例分析详情</span>
        </dt>
				<dd></dd>
			</dl>
			<dl class="mainBox">
				<dt class="tip">
					<div class="dtBox">
						<h2>{{name}}</h2>
					</div>
					<p>{{time}}</p>
				</dt>
				<dd class="content">
					<p>{{content}}</p>
				</dd>
			</dl>
		</div>
	</main>
</template>
<script>

	export default {
		name: 'CaseDetails',
		created() {
			this.caseId = this.$route.query.caseId;
			this.getCaseDetailsData();
		},
		data() {
			return {
				caseId:'',
				name: '',
				like: 0,
				time: '',
				content: '',
			}
		},
		methods: {
			getCaseDetailsData() {
				const params = {
					caseId: this.caseId,
				}
				this.$api.getCaseDetailsData(params).then(r => {
					if (r.code === 1) {
						this.name = r.data.name;
						this.like = r.data.like;
						this.time = r.data.time;
						this.content = r.data.content;
					}
				})
			},
		},
	}

</script>
<style lang="scss" scoped>
	@import './CaseDetails.scss';
</style>
